export default __webpack_public_path__ + "static/media/img_logo.e1943dbe.png";